export const LANDING_FAQ_DATA = [
  {
    id: "landing-panel-1",
    question: "What is Law Blocks AI, and how does it work?",
    answer:
      "Law Blocks AI is a cutting-edge platform that combines artificial intelligence and blockchain technology to offer efficient legal solutions. It provides tools like AI-generated legal documents, blockchain-secured document storage, AI legal chat, digital signatures, and a global marketplace for legal counselors. Simply sign up, explore the features, and start managing your legal needs effortlessly.",
  },
  {
    id: "landing-panel-2",
    question:
      "How can I upload and store legal documents securely on Law Blocks AI?",
    answer:
      "Uploading documents is simple with Law Blocks AI. Once logged in, you can upload your legal documents to the XDC Blockchain Network, ensuring data integrity, transparency, and security. The blockchain's immutable nature protects your documents from unauthorized access or changes.",
  },
  {
    id: "landing-panel-3",
    question: "Can I earn free LBT tokens on Law Blocks AI?",
    answer:
      "Yes! Law Blocks AI offers free LBT tokens for new users. These tokens can be used for features like purchasing ready-made legal documents, uploading files to the blockchain, or exploring other platform tools. It's an excellent way to get started on your legal journey.",
  },
  {
    id: "landing-panel-4",
    question: "What legal services does the AI legal chat feature provide?",
    answer:
      "The AI legal chat on Law Blocks AI offers real-time assistance for your legal queries. It provides guidance on creating documents, understanding legal terms, and accessing relevant laws based on your requirements. It's like having a legal expert at your fingertips 24/7.",
  },
  {
    id: "landing-panel-5",
    question: "How does Law Blocks AI facilitate dispute resolution?",
    answer:
      "Law Blocks AI supports Alternative Dispute Resolution (ADR) through features like Web3-based arbitration and mediation. You can connect with experienced legal counselors globally to resolve disputes efficiently, avoiding the hassle and expense of traditional court proceedings.",
  },
];

export const API_FAQ_DATA = [
  {
    id: "api-panel-1",
    question: "What is the Law Blocks AI API?",
    answer:
      "The Law Blocks AI API is an open Application Programming Interface that lets developers and businesses programmatically access AI-powered legal services including document generation, blockchain-based e-signatures, smart contracts, and dispute resolution and embed them directly into their own applications.",
  },
  {
    id: "api-panel-2",
    question: "Who is the API built for?",
    answer:
      "It is designed for developers, law firms, SMEs, NBFCs, and enterprise legal teams who want to integrate intelligent legal automation into their platforms without building the underlying infrastructure from scratch.",
  },
  {
    id: "api-panel-3",
    question: "How do I authenticate with the API?",
    answer:
      "Authentication is token-based. Every API request must include a valid API key or bearer token in the request header. Credentials are obtained after signing up at market.lawblocks.io.",
  },
  {
    id: "api-panel-4",
    question: "What can I build using the API?",
    answer:
      "You can build applications that generate AI-drafted legal documents, collect blockchain-based e-signatures, store contracts on the XDC blockchain or IPFS, initiate dispute resolution proceedings, connect clients with verified lawyers via the Lawyer Marketplace, and offer AI Legal Chat for legal guidance.",
  },
  {
    id: "api-panel-5",
    question:
      "Does the API support multiple countries and legal jurisdictions?",
    answer:
      "Yes. The document generation endpoints allow you to specify the country and state, producing legal documents tailored to the applicable local laws and regulatory framework.",
  },
  {
    id: "api-panel-6",
    question: "How are documents secured and stored?",
    answer:
      "Documents are cryptographically signed by all parties and stored immutably on the XDC blockchain and/or IPFS. This creates a tamper-proof, permanently verifiable record without dependence on any centralized server.",
  },
  {
    id: "api-panel-7",
    question: "Why is the XDC blockchain used instead of others?",
    answer:
      "XDC (XinFin) offers near-zero gas fees, at least 2,000 transactions per second, 2-second block times, and an enterprise-grade hybrid blockchain architecture making it practical and cost-efficient for real-world legal document use cases.",
  },
  {
    id: "api-panel-8",
    question: "What is the role of the LBT token in API usage?",
    answer:
      "LBT (Law Blocks Token) is the XRC-20 utility token that powers the ecosystem. Certain API actions such as uploading documents to the blockchain, filing disputes, or accessing premium services require LBT as the medium of exchange.",
  },
  {
    id: "api-panel-9",
    question: "Where can I find documentation and developer support?",
    answer:
      "Full API documentation is available at market.lawblocks.io/api-docs. For support, you can reach the team via Telegram (t.me/LawBlocks_updates), Discord (discord.gg/e9cKqusTDB), or the GitHub repository at github.com/lawblocks.",
  },
];
